<template>
  <div class="page-6">
    <div class="title">
      <div class="title-header">疑问答疑</div>
      <p class="title-content">飞天云手机，安卓10，月卡28元，功能强大，内置多种免费强大的游戏工具，超长时间待机，打造属于您的游戏专机。</p>
    </div>

    <div class="main">
      <page-6-item v-for="(item, i) in page5ItemData" :key="i" :title="item.title" :text="item.text" />
    </div>
  </div>
</template>

<script>
import Page6Item from "./item/Page6Item.vue";
export default {
  name: "Page6",
  components: { Page6Item },
  data() {
    return {
      page5ItemData: [
        { title: "01. 飞天云手机能干什么？", text: "飞天云手机采用真机远程控制，为您提供长期挂载游戏、应用的手机云平台。" },
        { title: "02. 飞天云手机贵吗？", text: "飞天云手机采用多方合作的运营模式，将会是市场最实惠、最便宜的云手机平台。" },
      ],
    };
  },
};
</script>

<style scoped>
.page-6 {
  width: 100%;
  padding: 80px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  background: #fff;
}

.title {
  max-width: 680px;
  width: 100%;
  text-align: center;
  margin-bottom: 48px;
}

.title-header {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
}

.title-content {
  font-size: 1rem;
  color: #555;
  line-height: 1.8;
  margin: 0;
}

.main {
  width: 100%;
  max-width: 860px;
}

@media screen and (max-width: 768px) {
  .page-6 {
    padding: 48px 16px;
  }
  .title-header {
    font-size: 1.6rem;
  }
  .title-content {
    font-size: 0.9rem;
  }
}
</style>
